const markupPrefix = 'evolife--'

export {
  markupPrefix
}
